import PropTypes from 'prop-types';
import React from 'react';
import PostCard from '../PostCard';

const CollectionStream = (props) => {
  const { posts, collection, arePostsLoading } = props;

  if (arePostsLoading) {
    return (
      <div className="container is-narrow">
        <div className="loading-block" />
      </div>
    );
  }

  return (
    <div className="container is-narrow">
      {posts && posts.length ? (
        <div className="posts">
          {posts.map((post, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={i}>
              {post ? (
                <PostCard
                  key={post.id}
                  post={post}
                  collection={collection}
                />
              ) : (
                ''
              )}
            </React.Fragment>
          ))}
        </div>
      ) : !arePostsLoading && (
        <div className="card has-background-dark">
          <div className="card-content has-text-white">
            <h2 className="title is-size-2 is-size-3-mobile has-text-white has-text-centered">
              Sorry, this collection doesn&apos;t contain any posts yet.
            </h2>
          </div>
        </div>
      )}
    </div>
  );
};

CollectionStream.propTypes = {
  posts: PropTypes.array,
  collection: PropTypes.object.isRequired,
  arePostsLoading: PropTypes.bool.isRequired,
};

CollectionStream.defaultProps = {
  posts: [],
};

export default CollectionStream;
